import GridColumn from "@/classes/component-classes/GridColumn";
import DocumentSearch from "@/classes/documents/DocumentSearch";
import DropDownItem from "@/classes/component-classes/DropDownItem";
import Validation from "@/classes/global/Validation";

export default class Documents {

    constructor() {

        this. cols = [
            new GridColumn('0', 'Action', 'view', '50', true, true, 50),
            new GridColumn('1', 'Job Number', 'jobNumber', '120', true, false, 80),
            new GridColumn('2', 'Document Title', 'docTitle', '300', true, false, 80),
            new GridColumn('3', 'Most Recent', 'recent', '80', true, false, 50),
            new GridColumn('4', 'Qty', 'quantity', '50', true, false, 50),
        ]

        this. selectedCols = [

            new GridColumn('0', 'Download', 'download', '60', true, true, 50),
            new GridColumn('1', 'Job Number', 'jobNumber', '110', true, false, 80),
            new GridColumn('2', 'Customer Ref', 'custRef', '130', true, false, 80),
            new GridColumn('3', 'Quote Number', 'quoteNumber', '130', true, true, 50),
            new GridColumn('4', 'InvoiceNumber', 'invoiceNumber', '130', true, true, 50),
            new GridColumn('5', 'Doc Title', 'docTitle', '195', true, true, 50),
            new GridColumn('6', 'Comment', 'comment', '200', true, true, 50),
            new GridColumn('7', 'Date', 'recent', '70', true, true, 50),

        ]

        this.documentSearchCriteria = new DocumentSearch();

        this.searchPills = {

            jobNumber: {history: [], enabled: true, validationFail: false},
            docTitle: {history:
                    [new DropDownItem('1', 'Invoice'),
                        new DropDownItem('2', 'POD'),
                        new DropDownItem('3', 'AWB'),
                        new DropDownItem('3', 'Email')], enabled: true, validationFail: false
            },

            date: {history: [], enabled: true, validationFail: new Validation() },
        }
        this.dataRange = "all"
        this.isSearchData = false;
        this.mainData = [];
        this.selectedData = [];

    }
}